import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {withRouter} from 'react-router-dom'

import ApiLogTable from "./ApiLogTable";
import {Input} from "react-materialize";

import apiLogActions from "../../../actions/apiLogActions";
import {DelayInput} from "react-delay-input";

class ApiLogs extends Component {

    constructor(props) {
        super(props);
        this.state = {
            availableApiList: this.props.apiLogs.apiList || [],
            selectedApi: this.props.apiLogs.selectedApi
        }
    }

    componentDidMount() {
        this.props.apiLogActions.getApiList();
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.apiLogs.apiList !== this.props.apiLogs.apiList) {
            this.setState({availableApiList: this.props.apiLogs.apiList});
        }

        if (prevProps.apiLogs.selectedApi !== this.props.apiLogs.selectedApi) {
            this.setState({selectedApi: this.props.apiLogs.selectedApi});
        }
    }

    handleChangeProvider = ({target}) => {
        const selectedApi = target.value;

        this.props.apiLogActions.setSelectedApi(selectedApi);
    };

    render() {
        let {availableApiList, selectedApi} = this.state;

        return (
            <div className="col s12">
                <div id="Forms" className="row ratiotable paddingbottomnone">
                    <div>
                        <h1 className="admin-subheader-text">
                            <span className="ratio-section-title">API-logboeken</span>
                        </h1>
                    </div>
                </div>

                <div className="row overviewkopbg ratiotable">
                    <div className="col s12 m4">
                        <div className="overviewkop">
                            <Input
                                type="select"
                                id="api"
                                name="api"
                                required={true}
                                multiple={false}
                                defaultValue={-1}
                                className="validate"
                                label="Toon logs voor API"
                                onChange={(e) => this.handleChangeProvider(e)}
                            >
                                <option value={null} key={-1}>Kies API</option>
                                {
                                    availableApiList.map((api) => {
                                        return (
                                            <option value={api.value} key={api.value}>
                                                {api.name}
                                            </option>
                                        );
                                    })
                                }
                            </Input>
                        </div>
                    </div>
                </div>

                <ApiLogTable />
            </div>
        );
    }
}

const mapStateToProps = ({apiLogs}) => {
    return {
        apiLogs
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        apiLogActions: bindActionCreators(apiLogActions, dispatch),
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ApiLogs));
